import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { createPortal } from 'react-dom';

type ToastContextType = (message: string, severity?: AlertColor) => void;

const ToastContext = createContext<ToastContextType>(() => {});

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('success');
  const [key, setKey] = useState(0);

  const showToast = (message: string, severity: AlertColor = 'success') => {
    setMessage(message);
    setSeverity(severity);
    setKey(prev => prev + 1);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {open &&
        createPortal(
          <Snackbar
            key={key}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            sx={{ zIndex: 9999 }} // Very high z-index to ensure it's above everything
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: '100%' }}
            >
              {message}
            </Alert>
          </Snackbar>,
          document.getElementById('toast-provider')
        )}
    </ToastContext.Provider>
  );
};
